import axios from "axios";
import { getSession, signOut } from "next-auth/react";

// Wichtig: In Browser-Requests nie "http://api:4000/api" verwenden.
// Das ist nur im Docker-Netz erreichbar.
// Nutze /api damit Caddy/Proxy richtig routet.
const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || "/api",
});

async function getAccessTokenWithRetry() {
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const session = await getSession();
    if (session?.accessToken) return session.accessToken;

    // Parallel laufende Session-/API-Anfragen können den ersten
    // getSession()-Aufruf noch ohne Access-Token beantworten.
    if (attempt < 2) {
      await new Promise((resolve) => window.setTimeout(resolve, 100));
    }
  }

  return null;
}

// Bearer automatisch anhängen
api.interceptors.request.use(async (config) => {
  const token = await getAccessTokenWithRetry();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let redirectingAfterUnauthorized = false;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response?.status === 401 &&
      typeof window !== "undefined" &&
      window.location.pathname !== "/login" &&
      !redirectingAfterUnauthorized
    ) {
      redirectingAfterUnauthorized = true;
      const next = `${window.location.pathname}${window.location.search}`;
      const callbackUrl = `/login?reason=unauthorized&next=${encodeURIComponent(next)}`;
      await signOut({ redirect: true, callbackUrl });
    }

    return Promise.reject(error);
  },
);

export default api;
